import {observable, computed, action} from 'mobx';

export default class WhiteSpaceStore {
  brochureSettings = null;
  title = null;
  //@observable value = 'exactly|5';

  constructor(brochureSettings, title = "title") {
    this.brochureSettings = brochureSettings;
    this.title = title;
  }

  @computed get whiteSpace() {
    return WhiteSpaceStore.toJson(this.brochureSettings[this.title]);
  }

  @computed get type() {
    return this.whiteSpace.type;
  }

  static toJson(str) {
    const arr = str.split('|');
    switch (arr[0]) {
      case 'exactly':
        return {
          type: 'exactly',
          value: arr[1]
        };
      case 'between':
        return {
          type: 'between',
          from: arr[1],
          to: arr[2]
        };
      case 'relativeTo':
        return {
          type: 'relativeTo',
          relativeTo: arr[1],
          relativeToType: arr[2],
          value: arr[3]
        };
      default:
        return {
          type: 'exactly',
          value: 0
        };
    }
  }

  @action setValue = (val) => {
    console.log('setValue', val);
    switch (val.type) {
      case 'exactly':
        this.brochureSettings[this.title] = `${val.type}|${val.value}`;
        break;
      case 'between':
        this.brochureSettings[this.title] = `${val.type}|${val.from}|${val.to}`;
        break;
      case 'relativeTo':
        this.brochureSettings[this.title] = `${val.type}|${val.relativeTo}|${val.relativeToType}|${val.value}`;
        break;
      case 'new':
        this.brochureSettings[this.title] = `${val.value}`;
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/SheetCalculator/Components/WhiteSpaceStore.js